import {
  BrainCircuit,
  Crown,
  FileText,
  GitBranch,
  LifeBuoy,
  MessagesSquare,
  MoreHorizontal,
  Shield,
  Sparkles,
  UserRound,
} from 'lucide-react'
import { Link } from 'react-router-dom'
import { useAuth } from '../auth-context.js'
import { useLanguage } from '../contexts/LanguageContext.jsx'

const ITEMS = {
  zh: [
    { to: '/weekly', label: '每日榜单', description: '查看今日榜单项目。', icon: Sparkles },
    { to: '/all-time', label: '总榜', description: '查看长期项目排行。', icon: GitBranch },
    { to: '/tools', label: '今日推荐', description: '查看今日推荐工具。', icon: Sparkles },
    { to: '/github-analysis', label: 'GitHub 项目分析', description: '分析项目亮点、简历价值和面试表达。', icon: BrainCircuit },
    { to: '/more/resume', label: '简历优化', description: '检查简历并生成优化建议。', icon: FileText },
    { to: '/more/interview', label: '面试准备', description: '按岗位方向准备面试表达。', icon: MessagesSquare },
    { to: '/vip', label: 'VIP 权益', description: '查看会员权益和使用额度。', icon: Crown },
    { to: '/support', label: '客服与反馈', description: '提交开通、退款和功能问题工单。', icon: LifeBuoy },
  ],
  en: [
    { to: '/weekly', label: 'Daily Ranking', description: 'View today ranked projects.', icon: Sparkles },
    { to: '/all-time', label: 'All-time Ranking', description: 'View long-term project rankings.', icon: GitBranch },
    { to: '/tools', label: 'Today Picks', description: 'Browse today recommended tools.', icon: Sparkles },
    { to: '/github-analysis', label: 'GitHub Analysis', description: 'Analyze project strengths and resume value.', icon: BrainCircuit },
    { to: '/more/resume', label: 'Resume Optimization', description: 'Improve resume structure and wording.', icon: FileText },
    { to: '/more/interview', label: 'Interview Prep', description: 'Prepare interviews by target role.', icon: MessagesSquare },
    { to: '/vip', label: 'VIP Benefits', description: 'View member benefits and usage limits.', icon: Crown },
    { to: '/support', label: 'Support', description: 'Submit activation, refund, and bug tickets.', icon: LifeBuoy },
  ],
}

const PAGE_COPY = {
  zh: {
    eyebrow: '更多',
    title: '更多入口',
    desc: '低频功能统一放在这里，主线成长功能保留在顶部导航。',
    aria: '更多功能入口',
    profile: '个人中心',
    profileDesc: '查看账号和收藏内容。',
    loginDesc: '登录后进入个人中心。',
    admin: '管理员后台',
    adminDesc: '仅管理员可见。',
  },
  en: {
    eyebrow: 'More',
    title: 'More Entries',
    desc: 'Lower-frequency pages stay here, while the main learning paths stay in the top navigation.',
    aria: 'More feature entries',
    profile: 'Profile',
    profileDesc: 'View account and saved items.',
    loginDesc: 'Log in to enter your profile.',
    admin: 'Admin Console',
    adminDesc: 'Visible to admins only.',
  },
}

function isAdminUser(user) {
  return user?.isAdmin === true || user?.is_admin === true
}

function MorePage() {
  const { user } = useAuth()
  const { language } = useLanguage()
  const copy = PAGE_COPY[language] || PAGE_COPY.zh
  const isAdmin = isAdminUser(user)
  const profileTarget = user ? '/profile' : '/login'
  const items = [
    ...(ITEMS[language] || ITEMS.zh),
    {
      to: profileTarget,
      label: copy.profile,
      description: user ? copy.profileDesc : copy.loginDesc,
      icon: UserRound,
    },
    ...(isAdmin ? [{
      to: '/admin',
      label: copy.admin,
      description: copy.adminDesc,
      icon: Shield,
    }] : []),
  ]

  return (
    <div className="page-container more-page">
      <section className="page-heading compact-heading">
        <div>
          <span className="eyebrow">{copy.eyebrow}</span>
          <h1>{copy.title}</h1>
          <p>{copy.desc}</p>
        </div>
        <MoreHorizontal size={22} />
      </section>

      <section className="more-entry-grid" aria-label={copy.aria}>
        {items.map((item) => {
          const Icon = item.icon
          return (
            <Link to={item.to} key={`${item.to}-${item.label}`} className="more-entry-card">
              <span><Icon size={18} /></span>
              <strong>{item.label}</strong>
              <small>{item.description}</small>
            </Link>
          )
        })}
      </section>
    </div>
  )
}

export default MorePage
